// The DAG portal lives at digitalwealthpartners.app in prod and
// digitalwealthpartners.dev in dev. Driven by REACT_APP_WEALTH_PORTAL_URL
// (from the wealth-portal-url secret), defaulting to prod when unset.
export const WEALTH_PORTAL_URL =
  process.env.REACT_APP_WEALTH_PORTAL_URL ||
  'https://digitalwealthpartners.app/';

// In production the LLC app is served on the same domain at /llc.
// In dev it runs on its own port (3000), so REACT_APP_LLC_URL overrides the base.
const LLC_UI_BASE = process.env.REACT_APP_LLC_URL ?? '';

export const llcUrl = (path = ''): string =>
  LLC_UI_BASE ? `${LLC_UI_BASE}${path}` : `/llc${path}`;

// In production the checkout app is served on the same domain at /checkout.
// In dev it runs on its own port (3002), so REACT_APP_CHECKOUT_UI_URL overrides the base.
const CHECKOUT_UI_BASE = process.env.REACT_APP_CHECKOUT_UI_URL ?? '';

export const checkoutUrl = (slug: string): string =>
  CHECKOUT_UI_BASE ? `${CHECKOUT_UI_BASE}/?id=${slug}` : `/checkout?id=${slug}`;

// Booking lives in the Checkout app (route /book), not the dashboard, so it must be
// built off the checkout base — using the dashboard's own base path 404s.
export const checkoutBookingUrl = (checkoutOrderId: number): string =>
  CHECKOUT_UI_BASE
    ? `${CHECKOUT_UI_BASE}/book?checkoutOrderId=${checkoutOrderId}`
    : `/checkout/book?checkoutOrderId=${checkoutOrderId}`;
